import React from "react";
//#region types
import { UserDisplayProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Profiles } from "components/common";
import ReadOnlyField from "components/common/forms/baseFields/readOnlyField";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const UserDisplay: React.FC<UserDisplayProps> = (props: UserDisplayProps) => {
  return (
    <ReadOnlyField label={props.label} className={cssExports.readOnlyTextField}>
      <Profiles.UserProfileLink {...props.value} />
    </ReadOnlyField>
  );
};

export default UserDisplay;
